// removed by extract-text-webpack-plugin
module.exports = {"container":"aaa2d5b67b_src-bootstrap-Errors-_Errors_container","errors":"_38958fc775_src-bootstrap-Errors-_Errors_errors"};


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/Errors/Errors.css
// module id = 1686
// module chunks = 0